var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-darkBlue"},[_c('h2',{staticClass:"text-2xl font-semibold"},[_vm._v(_vm._s(_vm.heading))]),_c('p',{staticClass:"text-xs"},[_vm._v(_vm._s(_vm.breadcrumb))])])
}
var staticRenderFns = []

export { render, staticRenderFns }